module.exports = __webpack_public_path__ + "img/order-list-b.476fecdd.svg";